export { default } from './FormControl';
export { default as useFormControl } from './useFormControl';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/FormControl/index.js
// module id = 320
// module chunks = 2